import '../scss/category-5260.scss';

jQuery(document).ready(function ($) {
	var $grid = $('.category-5260 .bc-products__grid');
	var $list = $grid.find('.bc-products__list');

	if (!$grid.length || !$list.length) {
		return;
	}

	// Hover gallery: cycle through up to three images (main + two extras) with a
	// fade, then revert to the main image when the pointer leaves.
	var HOVER_INTERVAL = 900;
	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function clearHoverTimer($product) {
		var timer = $product.data('bcHoverTimer');
		if (timer) {
			clearInterval(timer);
			$product.removeData('bcHoverTimer');
		}
	}

	function isSlideReady(img) {
		return !!(img && img.complete && img.naturalWidth > 0);
	}

	// Warm gallery extras so the first hover fade never lands on an unloaded image.
	function preloadGallerySlides(productEl) {
		if (!productEl || productEl.getAttribute('data-bc-preloaded') === '1') {
			return;
		}

		var slides = productEl.querySelectorAll('.bc-product__img-slide');
		if (slides.length < 2) {
			return;
		}

		productEl.setAttribute('data-bc-preloaded', '1');

		Array.prototype.forEach.call(slides, function (img, index) {
			if (index === 0) {
				return;
			}

			img.loading = 'eager';

			if (typeof img.decode === 'function') {
				img.decode().catch(function () {});
			} else if (!isSlideReady(img) && img.currentSrc) {
				var warmer = new Image();
				warmer.src = img.currentSrc;
			}
		});
	}

	function observeGalleryPreload(rootEl) {
		var products = (rootEl || $grid[0]).querySelectorAll('.bc-product--has-gallery:not([data-bc-preloaded="1"])');

		if (!products.length) {
			return;
		}

		if (!('IntersectionObserver' in window)) {
			Array.prototype.forEach.call(products, preloadGallerySlides);
			return;
		}

		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) {
					return;
				}

				preloadGallerySlides(entry.target);
				observer.unobserve(entry.target);
			});
		}, {
			// Start fetching a little before the tile scrolls into view.
			rootMargin: '200px 0px',
			threshold: 0.01
		});

		Array.prototype.forEach.call(products, function (product) {
			observer.observe(product);
		});
	}

	function showHoverSlide($slides, index) {
		$slides.removeClass('is-active');
		$slides.eq(index).addClass('is-active');
	}

	function stopHoverCycle($product) {
		clearHoverTimer($product);
		showHoverSlide($product.find('.bc-product__img-slide'), 0);
		$product.removeData('bcHoverIndex');
	}

	function advanceWhenReady($product, $slides, index) {
		var img = $slides.get(index);

		if (isSlideReady(img)) {
			showHoverSlide($slides, index);
			$product.data('bcHoverIndex', index);
			return;
		}

		// Image still in flight — wait for it rather than fading to the empty card.
		preloadGallerySlides($product[0]);

		var onReady = function () {
			if (!$product.data('bcHoverTimer') && $product.data('bcHoverIndex') === undefined) {
				return;
			}

			showHoverSlide($slides, index);
			$product.data('bcHoverIndex', index);
		};

		if (img) {
			$(img).one('load', onReady);
		}
	}

	function startHoverCycle($product) {
		if (reduceMotion || !$product.hasClass('bc-product--has-gallery')) {
			return;
		}

		var $slides = $product.find('.bc-product__img-slide');
		if ($slides.length < 2) {
			return;
		}

		clearHoverTimer($product);
		preloadGallerySlides($product[0]);

		// Swap to the first additional image immediately on hover (once ready).
		var index = 1;
		advanceWhenReady($product, $slides, index);

		var timer = setInterval(function () {
			index = (index + 1) % $slides.length;
			advanceWhenReady($product, $slides, index);
		}, HOVER_INTERVAL);

		$product.data('bcHoverTimer', timer);
	}

	observeGalleryPreload();

	// Delegated so tiles loaded by the "show more" AJAX still get the cycle.
	$grid.on('mouseenter', '.bc-product--has-gallery', function () {
		startHoverCycle($(this));
	});

	$grid.on('mouseleave', '.bc-product--has-gallery', function () {
		stopHoverCycle($(this));
	});

	// Show more pagination (desktop)
	if ($(window).width() > 800) {
		var currentUrl = window.location.href;
		var page = 2;
		var urlParts = currentUrl.split('?');
		var nextPage = urlParts[1]
			? urlParts[0] + 'page/' + page + '/'
			: urlParts[0] + 'page/' + page + '/?' + urlParts[1];

		$.ajax({
			type: 'GET',
			cache: false,
			url: nextPage,
			success: function (response) {
				var $responseProducts = $(response).find('.bc-products__list .bc-product');

				if (!$responseProducts.length) {
					return;
				}

				$grid.append(
					'<div class="show_more"><button type="button" class="show_more__btn">' +
					'View more</button></div>'
				);

				var $newPage = $('<div class="products bc-products__list page"></div>');
				$newPage.append($responseProducts);
				$grid.append($newPage);
				observeGalleryPreload($newPage[0]);

				$grid.on('click', '.show_more__btn', function () {
					$newPage.addClass('page--show');
					$grid.find('.show_more').addClass('hide');

					page++;
					var loadUrl = urlParts[1]
						? urlParts[0] + 'page/' + page + '/'
						: urlParts[0] + 'page/' + page + '/?' + urlParts[1];

					$.ajax({
						type: 'GET',
						cache: false,
						url: loadUrl,
						success: function (nextResponse) {
							var $moreProducts = $(nextResponse).find('.bc-products__list .bc-product');

							if ($moreProducts.length) {
								var $nextPage = $('<div class="products bc-products__list page"></div>');
								$nextPage.append($moreProducts);
								$grid.find('.show_more').before($nextPage);
								$grid.find('.show_more').removeClass('hide');
								observeGalleryPreload($nextPage[0]);
							}
						}
					});
				});
			}
		});
	}
});
